<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('suppliers.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="showExport = true">
                        {{ $t('suppliers.export') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="showExport" persistent max-width="90%" style="width: 500px !important;">
                <v-card style="width:500px !important">
                    <v-card-title class="justify-center mt-4">
                        <v-row align="center" justify="center" class="my-2">
                            <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('suppliers.export_data')}}</label>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-0 my-0 text-center">
                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu2" :model="report.initial_date" :label="$t('suppliers.initial_date')" @model="updateDate($event)" :rules_required="rules_required"></datepicker>
                            </v-col>

                            <v-col cols="6" class="py-0">
                                <datepicker :open_dialog="menu3" :model="report.final_date" :label="$t('suppliers.final_date')" @model="updateDateFinal($event)" :rules_required="rules_required"></datepicker>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="showExport = false">{{ $t('suppliers.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="exportData">
                                {{ $t('suppliers.export') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('suppliers.id'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('suppliers.name'), align: "center", value: 'name', class: 'text-uppercase' },
                { text: this.$t('suppliers.business_name'), align: "center", value: 'social_reason', class: 'text-uppercase' },
                { text: this.$t('suppliers.nac'), align: "center", value: 'national', class: 'text-uppercase' },
                { text: this.$t('suppliers.immex'), align: "center", value: 'immex_ssn', class: 'text-uppercase' },
                { text: this.$t('suppliers.rfe'), align: "center", value: 'rfe_idc', class: 'text-uppercase' },
                { text: this.$t('suppliers.rfc_curp'), align: "center", value: '', class: 'text-uppercase' },
                { text: this.$t('suppliers.street'), align: "center", value: 'street', class: 'text-uppercase' },
                { text: this.$t('suppliers.country'), align: "center", value: 'contry', class: 'text-uppercase' },
                { text: this.$t('suppliers.state'), align: "center", value: 'state', class: 'text-uppercase' },
                { text: this.$t('suppliers.zipcode'), align: "center", value: 'zipcode', class: 'text-uppercase' },
                { text: this.$t('suppliers.external_number'), align: "center", value: 'external_number', class: 'text-uppercase' },
                { text: this.$t('suppliers.neighborhood'), align: "center", value: 'neighborhood', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            menu2: false,
            menu3: false,
            showExport: false
        }
    },
    mounted(){
        // this.index();
        this.$store.state.module = "headers.suppliers";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        updateDate(newDate){
            this.report.initial_date = newDate;
        },
        updateDateFinal(date){
            this.report.final_date = date;
        },
        index(){
            this.props.items = [];
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'customs/catalogs/suppliers', {headers: {Authorization: lsToken}})
            .then((response) => {
                response.data.data.forEach(x => {
                    if(x.is_national == 1) x['national'] = this.$t('suppliers.yes');
                    else x['national'] = this.$t( 'suppliers.no');
                    this.props.items.push(x);
                })
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        exportData(){

        }
    }
}
</script>

<style>
</style>